"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getMainColor = void 0;
var _icfPlatformid = require("@atg/icf-platformid");
var _tinycolor = require("@ctrl/tinycolor");
var _getTranslucentBackground = _interopRequireDefault(require("../../utils/getTranslucentBackground"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
/**
 * @copyright
 * Copyright (c) 2023 Accretive Technology Group, Inc. All rights
 * reserved. For use only by Accretive Technology, its employees
 * and contractors. DO NOT DISTRIBUTE.
 */

var getMainColor = exports.getMainColor = function getMainColor(translucent, backgroundOpacity, color, theme, platformId) {
  var def = platformId === _icfPlatformid.PlatformId.streamate ? theme.colors.baseContrast015 : theme.colors.baseContrast040;
  if (backgroundOpacity !== undefined) {
    if (color) {
      return (0, _getTranslucentBackground.default)(theme.colors[color], backgroundOpacity);
    }
    return (0, _getTranslucentBackground.default)(def, backgroundOpacity);
  }
  var defaultColor = translucent ? theme.colors.baseContrast070 : def;
  return new _tinycolor.TinyColor(color ? theme.colors[color] || color : defaultColor).toHexString();
};